import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
/**
 * @deprecated Use Button Group instead.
 * Link to documentation: https://test-meine.wienenergie.at/dokumentation/ui-components/buttons/button-group
 * The better approach is to use the Button Group as a css wrapper and to have buttons inside this wrapper.
 */
@Component({
  selector: 'mwe-tab-buttons',
  templateUrl: './tab-buttons.component.html',
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabButtonsComponent {
  leftButtonId = input<string>();
  rightButtonId = input<string>();
  leftButtonLabel = input<string>();
  rightButtonLabel = input<string>();
  isActive = input<boolean>(true);

  leftButtonAction = output<void>();
  rightButtonAction = output<void>();

  onClickLeft() {
    this.leftButtonAction.emit();
  }

  onClickRight() {
    this.rightButtonAction.emit();
  }
}
